var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.4414 19.1133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 19.1133,
    opacity: 0,
    width: 19.4414,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5117C0 18.1406 0.984375 19.1016 2.625 19.1016L16.4648 19.1016C18.1172 19.1016 19.0898 18.1406 19.0898 16.5117L19.0898 2.58984C19.0898 0.960938 18.1172 0 16.4648 0L2.625 0C0.984375 0 0 0.960938 0 2.58984Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopfill);
export default __webpack_public_path__ + "static/media/stop.fill.7687409c329c41d531bd85290dcfdbee.svg";
export { ForwardRef as ReactComponent };